// components/share-buttons.tsx
import LinkIcon from '@/components/icons/link-icon';
import { TelegramIcon } from '@/components/icons/telegram';
import { VkIcon } from '@/components/icons/vk';
import { getShareLinks } from '@/utils/social-share';
import { showWarningToast, showSuccessToast } from '@/components/ui/sonner';

interface ShareButtonsProps {
  title: string;
  linkToShare?: string;
  variant?: 'default' | 'preview';
}

export const ShareButtons = ({ title, linkToShare, variant = 'default' }: ShareButtonsProps) => {
  const getShareUrl = () => {
    if (typeof window === 'undefined') return '';
    return linkToShare || window.location.href;
  };

  const handleCopyLink = async () => {
    const url = getShareUrl();
    if (!url) return;
    try {
      await navigator.clipboard.writeText(url);
      showSuccessToast('Ссылка скопирована в буфер обмена');
    } catch (err) {
      console.error('Ошибка при копировании:', err);
      showWarningToast('Не удалось скопировать ссылку');
    }
  };

  const handleShare = (platform: 'telegram' | 'vk') => {
    const url = getShareUrl();
    if (!url) return;

    const shareLinks = getShareLinks(url, title);
    const shareUrl = shareLinks[platform];

    const windowFeatures =
      platform === 'vk' ? 'width=600,height=400,noopener,noreferrer' : 'noopener,noreferrer';

    window.open(shareUrl, '_blank', windowFeatures);
  };

  const buttons = [
    {
      id: 'copy',
      onClick: handleCopyLink,
      color: '#A84DFF',
      Icon: LinkIcon,
      title: 'Копировать ссылку',
    },
    {
      id: 'telegram',
      onClick: () => handleShare('telegram'),
      color: '#FF3DAE',
      Icon: TelegramIcon,
      title: 'Поделиться в Telegram',
    },
    {
      id: 'vk',
      onClick: () => handleShare('vk'),
      color: '#505CFF',
      Icon: VkIcon,
      title: 'Поделиться в VK',
    },
  ];

  const isPreview = variant === 'preview';

  return (
    <div
      className={`flex ${isPreview ? 'flex-col md:flex-row md:items-center' : 'items-center'} justify-center gap-2 md:gap-2 mt-3 ${!isPreview ? 'max-xs:flex-col' : ''}`}
    >
      <span className="text-[#898989] text-[10px] font-medium">Поделиться</span>
      <div
        className={`flex items-center gap-0.5 ${isPreview ? 'w-fit mx-auto md:mx-0 rounded-[35px] bg-[#F2F3F7] p-[5px] md:bg-transparent md:p-0 md:rounded-none' : 'max-xs:w-fit max-xs:mx-auto max-xs:rounded-full max-xs:bg-[#F2F3F7] max-xs:p-2'}`}
      >
        {buttons.map(({ id, onClick, color, Icon, title }) => (
          <button
            key={id}
            onClick={onClick}
            title={title}
            className="w-7 h-7 rounded-full hover:opacity-80 transition-opacity flex items-center justify-center"
            style={{ backgroundColor: color }}
          >
            <Icon className="w-3.5 h-3.5 text-white [&_path]:fill-white" />
          </button>
        ))}
      </div>
    </div>
  );
};
